import { useDispatch } from 'react-redux'
import { authAction} from '../hooks/actions/mainAction'
import { menuAction } from 'hooks/actions/etcAction'

function ToLogin () {
  const dispatch = useDispatch()
  // console.log("이거 실행?")
  dispatch(authAction(false, null))
  dispatch(menuAction(null, null))
}

export default ToLogin